(function () {
    angular.module('components.relatedContent', [
        'utility',        
        'ngAnimate'
    ])        
        .directive('relatedContent', relatedContent)
        .controller('relatedContentController', relatedContentController);
 
    relatedContentController.$inject = ['$scope', 'global']
    function relatedContentController($scope, global) {
        var controller = this;
       
        $scope.content = global.relatedContent.get({ id: $scope.id }, function (data) {
            $scope.maxCharacters = data.maxCharacters;            
            $scope.emptySectionText = data.emptySectionText;
            $scope.news = data.news;
            $scope.projects = data.projects;
            $scope.resources = data.resources;
            $scope.services = data.services;
            $scope.technologies = data.technologies;
            $scope.isEmployeeView = data.isEmployeeView;
            $scope.hideSection = (data.news === undefined || data.news.length < 1) && (data.projects === undefined || data.projects.length < 1) &&
                (data.services === undefined || data.services.length < 1) && (data.resources === undefined || data.resources.length < 1);            
        });
    }

    relatedContent.$inject = ['$window', '$filter', '$timeout', 'global'];
    function relatedContent($window, $filter, $timeout, global) {
        var directive = {
            scope: {
                id: '='
            },
            templateUrl: '/angular/components/relatedContent/relatedContent.html',
            replace: true,
            restrict: 'E',
            link: link,
            controller: 'relatedContentController',
        };
        return directive;
        function link(scope, element, attrs) {
            
        }
    }

})();